import React, { useState } from "react";
import styles from "../cssModules/FilterComponent.module.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const FilterComponent = () => {
  const [date, setDate] = useState("");

  const handleChange = (event) => {
    setDate(event.target.value);
  };

  return (
    <div className={`${styles.filter_container} container-fluid`}>
      <FormControl sx={{ m: 1, minWidth: 120, width: "50%" }} size="small">
        <InputLabel id="demo-select-small-label">Date</InputLabel>
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={date}
          label="Age"
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>New to old</MenuItem>
          <MenuItem value={20}>Old to New</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default FilterComponent;
